import { useContext, useEffect, useState } from '@wordpress/element';
import { CampoInput } from '@componentsNew/Input/CampoInput';
import EstruturaPostContext from '@pages/DicasOtimizacao/Context/EstruturaPostContext';

function Slug({ nota, carregando }) {

  return (
    <>
      <CampoInput
        objetoInterno={true}
        label={'Slug'}
        campoEstrutura={'slug'}
        carregando={carregando}
        nota={nota}
        alerta={nota?.conteudo?.existe}
        mensagem="O slug já está em uso em outro post. Salvar slugs duplicados pode causar falhas, impedindo o registro correto."
      />
    </>
  );
}

export default Slug;
